export enum TrackingUpdateStatuses {
  InTransit = 'in_transit',
  OutForDelivery = 'out_for_delivery',
  UnsuccessfulDeliveryAttempt = 'unsuccessful_delivery_attempt',
  Exception = 'exception',
  Delivered = 'delivered',
}
